import * as find from './reducers/find';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    POSTCODE_FIND_REQUEST: find.request,
    POSTCODE_FIND_FINISH: find.finish,
    POSTCODE_FIND_ERROR: find.error,
    POSTCODE_FIND_CLEAR: find.clear,
});
